import { useState } from 'react'
import { FormikProvider, useFormik } from 'formik'
import * as yup from 'yup'

import { Button, Form, Dialog } from '@/ui'
import { putSignEmployeeForm } from '../payrollActions'
import { useAppDispatch } from '@/utils/typeHelpers'
import { Gusto_GustoForm } from '../generated_gusto_types'

// TODO: Migrate to V2
import { makeReqStringSchema } from '@/base'

const validationSchema = yup.object({
  agree: yup.boolean().isTrue(),
  name: makeReqStringSchema({ field: 'name' }),
})

export const SignFormModal = ({
  form,
  employeeUuid,
  onFormSigned,
  closeModal,
  open,
}: {
  form: Gusto_GustoForm
  employeeUuid?: string
  onFormSigned: (val: boolean) => void
  closeModal: () => void
  open: boolean
}) => {
  const { name, uuid } = form
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()

  const formik = useFormik({
    initialValues: {
      agree: false,
      name: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      if (!employeeUuid) {
        return
      }
      setLoading(true)
      const res = await putSignEmployeeForm(employeeUuid, uuid, {
        signature_text: values.name,
        agree: values.agree,
      })(dispatch)
      setLoading(false)
      if (res) {
        onFormSigned(res.requires_signing)
        closeModal()
      }
    },
  })

  const title =
    name === 'employee_direct_deposit'
      ? 'Sign Employee Direct Deposit Authorization'
      : 'Sign Form'
  const checkboxLabel =
    name === 'employee_direct_deposit'
      ? 'I allow Heard to directly deposit my pay into the bank account I’ve provided. This will remain in effect until I’ve notified Heard in writing to cancel this authorization.'
      : 'I’ve read the document and give authorization. This will remain in effect until I’ve notified Heard in writing to cancel this authorization.'

  return (
    <Dialog open={open} onOpenChange={(open) => !open && closeModal()}>
      <Dialog.Content>
        <Dialog.Title>{title}</Dialog.Title>

        <FormikProvider value={formik}>
          <div className="flex flex-col gap-4 mt-4">
            <Form.Checkbox name="agree" label={checkboxLabel} />
            <Form.Input
              name="name"
              label="Signature"
              placeholder="Enter full name"
            />
          </div>
        </FormikProvider>

        <Dialog.Footer className="my-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button onClick={formik.submitForm} loading={loading}>
            Sign
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
